// extracted by mini-css-extract-plugin
export var animationContainer = "_gv-0";
export var footer = "_gv-1";
export var gray = "_gv-2";
export var lineItem = "_gv-3";
export var lineItemImage = "_gv-4";
export var lineItemInfo = "_gv-5";
export var lineItemText = "_gv-6";
export var lineItems = "_gv-7";
export var modalContent = "_gv-8";
export var options = "_gv-9";
export var orderName = "_gv-a";
export var refundAmount = "_gv-b";